__turbopack_context__.v({
  "className": "shippori_mincho_2d429a7d-module__mhn_cq__className",
});
